const ROUTE_META = [
  {
    key: 'dashboard',
    matches: ['/home', '/dashboard'],
    icon: 'el-icon-s-home',
    titleKey: 'nav.dashboard',
    group: 'workspace',
    aliases: ['/home', '/dashboard']
  },
  {
    key: 'lead',
    matches: ['/lead', '/leads'],
    icon: 'el-icon-user',
    titleKey: 'nav.leads',
    group: 'pipeline'
  },
  {
    key: 'customer',
    matches: ['/customer', '/customers'],
    icon: 'el-icon-s-custom',
    titleKey: 'nav.customers',
    group: 'pipeline'
  },
  {
    key: 'quote',
    matches: ['/quote', '/quotes'],
    icon: 'el-icon-s-order',
    titleKey: 'nav.quotes',
    group: 'pipeline'
  },
  {
    key: 'contract',
    matches: ['/contract', '/contracts'],
    icon: 'el-icon-document',
    titleKey: 'nav.contracts',
    group: 'pipeline'
  },
  {
    key: 'changeOrder',
    matches: ['/change-order'],
    icon: 'el-icon-edit-outline',
    titleKey: 'nav.changeOrders',
    group: 'pipeline'
  },
  {
    key: 'project',
    matches: ['/project', '/projects'],
    icon: 'el-icon-s-management',
    titleKey: 'nav.projects',
    group: 'pipeline'
  },
  {
    key: 'product',
    matches: ['/product', '/products'],
    icon: 'el-icon-goods',
    titleKey: 'nav.products',
    group: 'pipeline'
  },
  {
    key: 'subcontractor',
    matches: ['/subcontractor', '/subcontractors'],
    icon: 'el-icon-s-cooperation',
    titleKey: 'nav.subcontractors',
    group: 'pipeline'
  },
  {
    key: 'finance',
    matches: ['/finance', '/finance/lead-cost', '/invoices', '/invoice', '/payment-plan'],
    icon: 'el-icon-money',
    titleKey: 'nav.finance',
    group: 'finance',
    aliases: ['/invoices']
  },
  {
    key: 'schedule',
    matches: ['/schedule'],
    icon: 'el-icon-date',
    titleKey: 'nav.schedule',
    group: 'workspace'
  },
  {
    key: 'report',
    matches: ['/report', '/reports'],
    icon: 'el-icon-s-marketing',
    titleKey: 'nav.reports',
    group: 'insights',
    aliases: ['/reports']
  },
  {
    key: 'salesAmount',
    matches: ['/sales-amount'],
    icon: 'el-icon-s-data',
    titleKey: 'nav.salesAmount',
    group: 'insights'
  },
  {
    key: 'template',
    matches: ['/system/contract-templates'],
    icon: 'el-icon-document-copy',
    titleKey: 'nav.templates',
    group: 'insights'
  },
  {
    key: 'emailConfig',
    matches: ['/system/mail-settings'],
    icon: 'el-icon-message',
    titleKey: 'nav.emailConfig',
    group: 'admin'
  },
  {
    key: 'systemOverview',
    matches: ['/system/overview'],
    icon: 'el-icon-odometer',
    titleKey: 'nav.systemOverview',
    group: 'admin'
  },
  {
    key: 'settings',
    matches: ['/system/users', '/system/roles', '/system/menus', '/system'],
    icon: 'el-icon-setting',
    titleKey: 'nav.settings',
    group: 'admin'
  }
]

export const NAV_GROUP_ORDER = ['workspace', 'pipeline', 'finance', 'insights', 'admin']

export function resolveRouteMeta(path) {
  const target = String(path || '')
  return ROUTE_META.find(item => item.matches.some(prefix => target.startsWith(prefix))) || null
}

export function routeIcon(path, fallback) {
  const meta = resolveRouteMeta(path)
  return (meta && meta.icon) || fallback || 'el-icon-menu'
}

export function routeTitleKey(path) {
  const meta = resolveRouteMeta(path)
  return meta ? meta.titleKey : ''
}

export function routeGroup(path) {
  const meta = resolveRouteMeta(path)
  return meta ? meta.group : 'pipeline'
}

export function normalizeRoute(path) {
  const target = String(path || '')
  const meta = resolveRouteMeta(target)
  if (!meta) return target
  const all = [...meta.matches, ...(meta.aliases || [])]
  // 同一 meta 下有多条前缀（如 /system/users、/system/roles）时，必须用「最长匹配」保留真实路径，
  // 否则非首项会被错误归一成 matches[0]，侧边栏 isRouteActive 会让多项同时高亮。
  const sorted = [...new Set(all)].sort((a, b) => b.length - a.length)
  const hit = sorted.find(p => target === p || target.startsWith(p + '/'))
  if (hit) return target
  const canonical = meta.matches[0]
  return target.startsWith(canonical) ? target : canonical
}
